




























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { replaceString } from '@/common/utils/dealWithString';
import fetch from '@/common/api/fetch';
import { DescItem } from '@/common/interface';
import getUrlParam from '@/common/utils/getUrlParam';
@Component({
  components: {},
})
export default class DistributeTabbar extends Vue {
  @Getter('section') section!: any;
  @Getter('courseDesc') getterCourseDesc!: Array<DescItem>;
  @Getter('leftQuota') leftQuota!: string;
  @Getter('showNum') showNum!: boolean;
  @Getter('payNumber') payNumber!: number;

  type: string = getUrlParam('type') as string;
  replaceString: Function = replaceString;
  get courseDescs(): Array<DescItem> {
    const tempArray: Array<DescItem> = [];
    for (let i: number = 0, length: number = this.getterCourseDesc.length; i < length; i++) {
      const item: DescItem = Object.assign({}, this.getterCourseDesc[i]);
      item.value = item.value && replaceString(item.value);
      tempArray.push(item);
    }
    return tempArray;
  }
  handleVideo(item: any) {
    fetch.parseUrl(item.value).then((res: any) => {
      const query = {
        url: res || item.value,
      };
      this.$router.push({
        name: 'video',
        query: query,
      });
    });
  }
}
